import React from 'react'
import { withTranslation } from 'react-i18next'
import withRouter from '../../../components/Common/withRouter'

const Modules = (props) => {
  return (
    <div>Modules</div>
  )
}

export default withRouter(withTranslation()(Modules))
